import Driver from '@/models/Driver'
import Service from '@/models/Service'

export class ServiceList extends Service {
	driver: Driver | null
}
